import { ActionTypes, IEdgeDevice } from './types';

export function setDevices(devices: IEdgeDevice[]) {
  return {
    type: ActionTypes.SET_ASSETS,
    devices
  }
}